import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        //Promo Slider
        pdpVideoContainer: {
            maxWidth: remCalc(1920),
            '.swiper': {maxWidth: remCalc(1920)},
        },
        container: {
            maxW: remCalc(1920),
            py: {base: remCalc(16), md: remCalc(40)},
            position: 'relative',
            margin: '0 auto',
            overflow: 'hidden',
            '.promo-slider-pagination': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: remCalc(8),
            },
            '.promo-slider-pagination .swiper-pagination-bullet': {
                width: remCalc(6),
                height: remCalc(6),
                borderRadius: 'full',
                opacity: 1,
                backgroundColor: 'background.base.deep',
                margin: '0 !important',
            },
            '.promo-slider-pagination .swiper-pagination-bullet-active': {
                width: remCalc(12),
                backgroundColor: 'background.strong.default',
            },
            '@media screen and (min-width: 450px) and (max-width: 767px)': {
                // paddingTop: remCalc(16),
                // paddingBottom: remCalc(16)
                py: remCalc(16),
            },
        },
        videoTitle: {
            textStyle: 'head-large',
            fontWeight: 'medium',
            w: '100%',
            textAlign: 'center',
            color: 'foreground.neutral.default',
            fontFamily: 'heading',
        },
        chevronIconContainer: {
            position: 'absolute',
            zIndex: '10',
            padding: 0,
            margin: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            top: '50%',
            lineHeight: 0,
            width: {base: remCalc(24), sm: remCalc(24), md: remCalc(32), lg: remCalc(40)},
            height: {base: remCalc(24), sm: remCalc(24), md: remCalc(32), lg: remCalc(40)},
            '@media screen and (min-width: 450px) and (max-width: 767px)': {
                width: remCalc(32),
                height: remCalc(32),
                top: '50%',
            },
        },

        chevronIcon: {
            width: {base: remCalc(24), md: remCalc(32), lg: remCalc(40)},
            height: {base: remCalc(24), md: remCalc(32), lg: remCalc(40)},
            position: 'absolute',
            top: {base: '30%', md: '50%'},
            transform: 'translateY(-100%)',
            backgroundColor: 'background.default',
            borderRadius: '50%',
            border: 'small',
            borderStyle: 'solid',
            cursor: 'pointer',
            zIndex: '10',
            '@media screen and (min-width: 450px) and (max-width: 767px)': {
                width: remCalc(32),
                height: remCalc(32),
                top: '50%',
            },
        },
        heading: {
            textAlign: 'center',
            px: remCalc(24),
            py: {base: remCalc(16), md: remCalc(40)},
            textStyle: ['head-large'],
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
            fontFamily: 'heading',
        },
        sliderLinkContainer: {
            _hover: {
                TextDecoration: 'none',
            },
        },
        sliderContainer: {
            mx: {base: remCalc(16), md: 'unset'},
            position: 'relative',
            flexDirection: {base: 'column', md: 'row'},
            alignItems: 'center',
            cursor: 'auto',
            borderRadius: 'large-1',
            overflow: 'hidden',
            '@media screen and (min-width: 450px) and (max-width: 767px)': {
                mx: 'unset',
                flexDirection: 'row',
            },
        },
        imageContainer: {
            width: {base: '100%', md: '50%'},
            flexShrink: '1',
            height: {base: '100%', md: remCalc(456), lg: remCalc(520)},
            overflow: 'hidden',
            '@media screen and (min-width: 450px) and (max-width: 767px)': {
                width: '50%',
                height: remCalc(456),
            },
        },
        contentContainer: {
            width: {base: '100%', md: '50%'},
            flexShrink: '0',
            // overflow: 'auto',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            height: {base: remCalc(334), md: remCalc(456), lg: remCalc(520)},
            backgroundColor: 'background.accent.default',
            px: {base: remCalc(24), md: remCalc(40), lg: remCalc(40)},
            py: {base: remCalc(24), md: remCalc(61), lg: remCalc(51), xl: remCalc(126)},
            '@media screen and (min-width: 450px) and (max-width: 767px)': {
                width: '50%',
                height: remCalc(456),
                px: remCalc(40),
                py: remCalc(51),
            },
        },
        //PromoSliderImage
        promoSlideImageContainer: {
            mx: {base: remCalc(16), md: 'unset'},
            cursor: 'auto',
        },
        promoSlideBackground: {
            overflow: 'hidden',
            borderRadius: 'large-1',
            _before: {
                content: '""',
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                bg: 'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6))',
                zIndex: '0',
            },
            bgSize: 'cover',
            bgPos: 'center',
            bgRepeat: 'no-repeat',
            w: '100%',
            maxW: {md: remCalc(640), lg: remCalc(688)},
            height: {base: remCalc(239), md: remCalc(320), lg: remCalc(369), xl: remCalc(415)},
            position: 'relative',
            '@media screen and (min-width: 450px) and (max-width: 767px)': {
                maxW: remCalc(640),
                h: remCalc(320),
            },
        },
        promoSlideBackgroundImage: {
            h: '100%',
        },
        promoSliderContent: {
            flexDirection: 'column',
            alignItems: 'center',
            gap: {base: 'small-1', md: 'medium'},
            position: 'absolute',
            bottom: {base: remCalc(24), md: remCalc(32), lg: remCalc(45)},
            align: 'center',
            w: '100%',
            maxW: {base: remCalc(285), md: remCalc(476), lg: remCalc(640)},
            left: '50%',
            transform: 'translateX(-50%)',
            '@media screen and (min-width: 450px) and (max-width: 767px)': {
                maxW: remCalc(476),
            },
        },
        // PromoSliderVideo
        promoSliderVideoContainer: {
            position: 'relative',
            width: '100%',
            maxWidth: {md: remCalc(640), lg: remCalc(688)},
            height: {base: remCalc(239), md: remCalc(320), lg: remCalc(369), xl: remCalc(415)},
            overflow: 'hidden',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderRadius: 'large-1',
            _before: {
                content: '""',
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                bg: 'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5))',
                zIndex: '0',
                pointerEvents: 'none',
            },
        },
        heroLeftRightArrowsContainer: {
            position: 'absolute',
            zIndex: 10,
            display: 'flex',
            height: remCalc(36),
            alignItems: 'center',
            justifyContent: 'center',
            color: 'foreground.neutral.inverse',
            borderRadius: 'full',
            bg: 'background.base.overlay',
            boxShadow: 'borderShadow',
            backdropFilter: 'blur(5px)',
            width: remCalc(36),
            border: 'small',
            borderColor: 'border.neutral.highlight',
            borderStyle: 'solid',
            transform: 'translateY(-50%)',
        },
        heroLeftRightArrows: {
            alignItems: 'center',
            justifyContent: 'center',
            boxSize: remCalc(16),
            userSelect: 'none',
            color: 'background.neutral.grey',
        },
        playIconContainer: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: '2',
        },
        playIcon: {
            width: '40px',
            height: '40px',
            fill: 'white',
        },
        contentOverlay: {
            display: {base: 'none', md: 'none', lg: 'block'},
            position: 'absolute',
            width: '100%',
            pointerEvents: 'auto',
            bottom: {lg: remCalc(45)},
            py: {lg: remCalc(35)},
            textAlign: 'center',
        },
        content: {
            flexDirection: 'column',
            alignItems: 'center',
            gap: {base: remCalc(24)},
            pt: remCalc(24),
            pointerEvents: 'none',
        },
        label: {
            textStyle: 'body-small',
            color: 'foreground.neutral.inverse',
            pb: {lg: remCalc(24)},
            fontWeight: 'bold',
        },
        title: {
            textStyle: 'body-medium',
            fontWeight: 'medium',
            color: 'foreground.neutral.inverse',
            fontFamily: 'heading',
        },
        textTitleDescription: {
            color: 'foreground.neutral.inverse',
            textStyle: 'head-large',
            fontWeight: 'medium',
            titleSpacing: remCalc(24),
            childrenTextColor: 'foreground.neutral.inverse',
            childrenTextStyle: 'body-large',
            mb: remCalc(24),
        },
        promoSliderCardButton: {
            variant: 'link-button',
            color: 'foreground.neutral.inverse',
        },
        imageCardChevronIcon: {
            boxSize: 'iconsSize.medium',
            color: 'inherit',
            pointerEvents: 'none',
        },
        promoSlideCardCta: {
            gap: 'small-1',
        },
        promoSliderImage: {
            w: '100%',
            height: '100%',
            objectFit: 'cover',
        },
        promoSlideCardText: {
            color: 'inherit',
        },
        promoSlideCardTextImage: {
            color: 'inherit',
            textStyle: 'body-medium',
        },
        textTitleDescriptionImage: {
            color: 'foreground.neutral.inverse',
            textStyle: 'head-large',
            fontWeight: 'medium',
            titleSpacing: {base: remCalc(16), md: remCalc(24)},
            childrenTextColor: 'foreground.neutral.inverse',
            childrenTextStyle: 'body-large',
            mb: {base: remCalc(16), md: remCalc(24)},
        },
        videoContainerYoutube: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 10,
            bg: 'transparent',
        },
    },
    variants: {
        paperlessVariant: {
            promoSliderVideoContainer: {
                height: {base: '100vw', md: remCalc(320), lg: remCalc(369), xl: remCalc(415)},
            },
            content: {
                position: 'absolute',
                bottom: '15%',
                left: '50%',
                transform: 'translateX(-50%)',
                color: 'foreground.neutral.inverse',
                width: '100%',
                textAlign: 'center',
            },
            label: {
                color: {sm: 'foreground.neutral.inverse', md: 'foreground.neutral.inverse'},
            },
            title: {
                textStyle: {base: 'head-small', md: 'head-large'},
                color: {base: 'foreground.neutral.inverse', md: 'foreground.neutral.inverse'},
                fontFamily: 'heading',
            },
        },
    },
}
